import { useState } from 'react';

const portfolioProjects = [
  {
    id: 1,
    title: 'Modern Kitchen Transformation',
    category: 'Kitchen',
    description: 'Complete kitchen renovation featuring custom white cabinets, quartz countertops, and stainless steel appliances.',
    image: 'https://public.readdy.ai/ai/img_res/5082d496743dc4b18277cc0efd0c7c8e.jpg',
    details: {
      duration: '6 weeks',
      size: '250 sq ft',
      features: ['Custom Cabinetry', 'Quartz Countertops', 'Subway Tile Backsplash', 'Pendant Lighting']
    }
  },
  {
    id: 2,
    title: 'Luxury Master Bathroom',
    category: 'Bathroom',
    description: 'Spa-like master bathroom with walk-in shower, double vanity, and premium marble finishes.',
    image: 'https://readdy.ai/api/search-image?query=Empty%20luxury%20master%20bathroom%20renovation%20with%20marble%20shower%20walls%2C%20floating%20double%20vanity%2C%20modern%20fixtures%2C%20glass%20shower%20door%2C%20no%20furniture%20or%20accessories%2C%20clean%20construction%20finish&width=800&height=600&seq=bathroom1empty&orientation=landscape',
    details: {
      duration: '4 weeks',
      size: '120 sq ft',
      features: ['Marble Tile Work', 'Double Vanity', 'Walk-in Shower', 'Heated Floors']
    }
  },
  {
    id: 3,
    title: 'Basement Entertainment Center',
    category: 'Basement',
    description: 'Transformed unfinished basement into a modern entertainment space with bar area and media room.',
    image: 'https://readdy.ai/api/search-image?query=Empty%20finished%20basement%20renovation%20with%20built-in%20entertainment%20center%2C%20wet%20bar%20area%2C%20recessed%20lighting%2C%20luxury%20vinyl%20flooring%2C%20no%20furniture%2C%20clean%20construction%20finish%20showing%20craftsmanship&width=800&height=600&seq=basement1empty&orientation=landscape',
    details: {
      duration: '8 weeks',
      size: '800 sq ft',
      features: ['Bar Installation', 'Media Center', 'Laminate Flooring', 'Recessed Lighting']
    }
  },
  {
    id: 4,
    title: 'Contemporary Kitchen Island',
    category: 'Kitchen',
    description: 'Stunning kitchen remodel with waterfall edge island, premium appliances, and custom lighting.',
    image: 'https://readdy.ai/api/search-image?query=Empty%20contemporary%20kitchen%20renovation%20with%20large%20waterfall%20edge%20island%2C%20premium%20stainless%20appliances%2C%20under%20cabinet%20lighting%2C%20modern%20backsplash%2C%20no%20furniture%2C%20clean%20construction%20finish&width=800&height=600&seq=kitchen3empty&orientation=landscape',
    details: {
      duration: '7 weeks',
      size: '320 sq ft',
      features: ['Waterfall Island', 'Premium Appliances', 'Custom Lighting', 'Modern Backsplash']
    }
  },
  {
    id: 5,
    title: 'Guest Bathroom Renovation',
    category: 'Bathroom',
    description: 'Complete guest bathroom makeover with modern fixtures and elegant tile work.',
    image: 'https://readdy.ai/api/search-image?query=Empty%20small%20guest%20bathroom%20renovation%20with%20modern%20vanity%2C%20decorative%20tile%20accent%20wall%2C%20contemporary%20mirror%2C%20efficient%20storage%2C%20bright%20lighting%2C%20no%20accessories%2C%20clean%20construction%20finish&width=800&height=600&seq=bathroom2empty&orientation=landscape',
    details: {
      duration: '3 weeks',
      size: '60 sq ft',
      features: ['Tile Installation', 'Vanity Upgrade', 'Modern Fixtures', 'Efficient Layout']
    }
  },
  {
    id: 6,
    title: 'Open Concept Kitchen',
    category: 'Kitchen',
    description: 'Removed walls to create open concept kitchen and living space with large island.',
    image: 'https://readdy.ai/api/search-image?query=Empty%20open%20concept%20kitchen%20renovation%20with%20large%20kitchen%20island%2C%20modern%20appliances%2C%20open%20floor%20plan%2C%20natural%20light%2C%20seamless%20flow%20between%20spaces%2C%20no%20furniture%2C%20clean%20construction%20finish&width=800&height=600&seq=kitchen2empty&orientation=landscape',
    details: {
      duration: '10 weeks',
      size: '400 sq ft',
      features: ['Wall Removal', 'Large Island', 'Open Floor Plan', 'Custom Storage']
    }
  },
  {
    id: 7,
    title: 'Basement Home Office',
    category: 'Basement',
    description: 'Converted basement space into a professional home office with built-in storage and modern finishes.',
    image: 'https://readdy.ai/api/search-image?query=Empty%20finished%20basement%20home%20office%20renovation%20with%20built-in%20desk%20area%2C%20custom%20shelving%2C%20professional%20lighting%2C%20carpet%20flooring%2C%20no%20furniture%2C%20clean%20construction%20finish&width=800&height=600&seq=basement2empty&orientation=landscape',
    details: {
      duration: '5 weeks',
      size: '300 sq ft',
      features: ['Built-in Desk', 'Custom Shelving', 'Professional Lighting', 'Sound Insulation']
    }
  },
  {
    id: 8,
    title: 'Master Bathroom Suite',
    category: 'Bathroom',
    description: 'Luxurious master bathroom with freestanding tub, separate shower, and dual vanities.',
    image: 'https://readdy.ai/api/search-image?query=Empty%20luxury%20master%20bathroom%20suite%20with%20freestanding%20bathtub%2C%20separate%20glass%20shower%2C%20dual%20vanities%2C%20marble%20flooring%2C%20elegant%20fixtures%2C%20no%20accessories%2C%20clean%20construction%20finish&width=800&height=600&seq=bathroom3empty&orientation=landscape',
    details: {
      duration: '6 weeks',
      size: '180 sq ft',
      features: ['Freestanding Tub', 'Separate Shower', 'Dual Vanities', 'Marble Flooring']
    }
  },
  {
    id: 9,
    title: 'Farmhouse Kitchen Remodel',
    category: 'Kitchen',
    description: 'Charming farmhouse-style kitchen with shaker cabinets, farmhouse sink, and rustic elements.',
    image: 'https://readdy.ai/api/search-image?query=Empty%20farmhouse%20kitchen%20renovation%20with%20white%20shaker%20cabinets%2C%20farmhouse%20sink%2C%20butcher%20block%20counters%2C%20rustic%20wood%20beams%2C%20no%20furniture%2C%20clean%20construction%20finish&width=800&height=600&seq=kitchen4empty&orientation=landscape',
    details: {
      duration: '8 weeks',
      size: '280 sq ft',
      features: ['Shaker Cabinets', 'Farmhouse Sink', 'Butcher Block Counters', 'Rustic Beams']
    }
  },
  {
    id: 10,
    title: 'Basement Game Room',
    category: 'Basement',
    description: 'Fun basement transformation into a game room with custom bar and entertainment features.',
    image: 'https://readdy.ai/api/search-image?query=Empty%20finished%20basement%20game%20room%20with%20custom%20built-in%20bar%2C%20entertainment%20area%2C%20modern%20flooring%2C%20recessed%20lighting%2C%20no%20furniture%20or%20games%2C%20clean%20construction%20finish&width=800&height=600&seq=basement3empty&orientation=landscape',
    details: {
      duration: '9 weeks',
      size: '600 sq ft',
      features: ['Custom Bar', 'Entertainment Area', 'Modern Flooring', 'Surround Sound']
    }
  }
];

const categories = ['All', 'Kitchen', 'Bathroom', 'Basement'];

export default function PortfolioSection() {
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [selectedProject, setSelectedProject] = useState<typeof portfolioProjects[0] | null>(null);

  const filteredProjects = selectedCategory === 'All' 
    ? portfolioProjects 
    : portfolioProjects.filter(project => project.category === selectedCategory);

  return (
    <section id="portfolio" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Our <strong>Portfolio</strong>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Explore our recent remodeling projects showcasing quality craftsmanship and attention to detail.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-4 mb-12">
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => setSelectedCategory(category)}
              className={`px-6 py-2 rounded-full cursor-pointer transition-all duration-200 whitespace-nowrap ${
                selectedCategory === category
                  ? 'bg-blue-600 text-white'
                  : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
              }`}
            >
              {category}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredProjects.map((project) => (
            <div 
              key={project.id}
              className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300 cursor-pointer"
              onClick={() => setSelectedProject(project)}
            >
              <div className="relative h-64">
                <img 
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute top-4 right-4 bg-blue-600 text-white px-3 py-1 rounded-full text-sm">
                  {project.category}
                </div>
              </div>
              
              <div className="p-6">
                <h3 className="text-xl font-semibold text-gray-900 mb-2">
                  {project.title}
                </h3>
                <p className="text-gray-600 mb-4">
                  {project.description}
                </p>
                <div className="flex items-center text-blue-600 font-medium">
                  <span>View Details</span>
                  <i className="ri-arrow-right-line ml-2"></i>
                </div>
              </div>
            </div>
          ))}
        </div>

        {selectedProject && (
          <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-lg max-w-4xl w-full max-h-[90vh] overflow-y-auto">
              <div className="relative">
                <img 
                  src={selectedProject.image}
                  alt={selectedProject.title}
                  className="w-full h-64 md:h-96 object-cover object-top"
                />
                <button
                  onClick={() => setSelectedProject(null)}
                  className="absolute top-4 right-4 bg-white text-gray-900 w-10 h-10 rounded-full flex items-center justify-center cursor-pointer hover:bg-gray-100"
                >
                  <i className="ri-close-line text-xl"></i>
                </button>
              </div>
              
              <div className="p-8">
                <div className="flex items-center gap-4 mb-4">
                  <h3 className="text-2xl font-bold text-gray-900">
                    {selectedProject.title}
                  </h3>
                  <span className="bg-blue-100 text-blue-600 px-3 py-1 rounded-full text-sm">
                    {selectedProject.category}
                  </span>
                </div>
                
                <p className="text-gray-600 mb-6">
                  {selectedProject.description}
                </p>
                
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-2">Duration</h4>
                    <p className="text-gray-600">{selectedProject.details.duration}</p>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-2">Size</h4>
                    <p className="text-gray-600">{selectedProject.details.size}</p>
                  </div>
                  <div>
                    <h4 className="font-semibold text-gray-900 mb-2">Features</h4>
                    <ul className="text-gray-600 space-y-1">
                      {selectedProject.details.features.map((feature, index) => (
                        <li key={index} className="flex items-center">
                          <i className="ri-check-line text-green-500 mr-2"></i>
                          {feature}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
